/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { createRoute } from '@gh/builder-shared';

import { TodoListComponent } from './components/todo-list/todo-list.component';
import { TodoListBusinessService } from './resources/todo-list-business.service';

const routes: Routes = [createRoute({
  path: '',
  component: TodoListComponent,
  init: TodoListBusinessService,
})];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderTodoRoutingModule {
}
